// UserModal.js
import React from 'react';
import './AssetsModal.css';

const AssetsModal = ({ isOpen, onClose }) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="assets-modal">
      <div className="assets-modal-content">
        <h2 className='assets-title'>Assets Modal</h2>
        {/* Add your modal content here */}
        <button onClick={onClose}>Close Modal</button>
      </div>
    </div>
  );
};

export default AssetsModal;
